import { useNavigate } from 'react-router-dom'
import { BackButton } from './BackButton'
import styles from './ApplicationMainToolbarContent.module.css'
import { useHasBackPage } from 'shared/hooks/useHasBackPage'

interface ApplicationMainToolbarContentProps {
    title: string
    back: {
        url?: string,
        callback?: (event: any) => void
        checkHasBackPage?: boolean
    }
}

export const ApplicationMainToolbarContent = (props: ApplicationMainToolbarContentProps): JSX.Element => {
    const {
        title,
        back
    } = props

    const navigate = useNavigate()
    const { hasBackPage } = useHasBackPage()

    const handleBackButtonClick = (event: any) => {
        if (back && back.callback !== undefined){
            back.callback(event)
        }

        if (back && back?.url !== undefined){
            navigate(back?.url)
        }      
    }

    const renderBackButton = () => {
        if (back?.checkHasBackPage === true){
            if (hasBackPage){
                return (
                    <BackButton onClick={handleBackButtonClick} />
                )
            }
            
            return null
        }

        return (
            <BackButton onClick={handleBackButtonClick} />
        )

    }

    return (
        <div className={styles.ApplicationMainToolbarContent}>
            <div className={styles.ApplicationMainToolbarContent__StartContainer}>
                {
                    renderBackButton()
                }
            </div>
            <div className={styles.ApplicationMainToolbarContent__CenterContainer}>
                <div className={styles.ApplicationMainToolbarContent__Title}>
                    {title}
                </div>
            </div>
            <div className={styles.ApplicationMainToolbarContent__EndContainer}>
            </div>
        </div>
    )
}